import dealingService from '../services/dealing.service';

export const dealing = {
  state: {
    purchases: [],
    sales: [],
    assetTransfersEquity: [],
    counters: [],
    unlistedCounters: [],
    reversals: []
  },

//********************************************************************GETTERS*****************************************************************************************
//********************************************************************************************************************************************************************

  getters: {
    allPurchases: (state) => state.purchases,
    allBondPurchases: (state) => state.purchases.filter(p => p.AssetType == 1),
    unconfirmedBondPurchases: (state) => {return [state.purchases.filter(p => p.CheckerID == 0 && p.AssetType == 1),[state.purchases.title = "Bond Purchases"]]},
    allEquityPurchases: (state) => state.purchases.filter(p => p.AssetType == 2),
    unconfirmedEquityPurchases: (state) => {return [state.purchases.filter(p => p.CheckerID == 0 && p.AssetType == 2),[state.purchases.title = "Equity Purchases"]]},
    allMMPurchases: (state) => state.purchases.filter(p => p.AssetType == 4),
    unconfirmedMMPurchases: (state) => {return [state.purchases.filter(p => p.CheckerID == 0 && p.AssetType == 4),[state.purchases.title = "Money Market Purchases"]]},
    allPropertyPurchases: (state) => state.purchases.filter(p => p.AssetType == 3),
    unconfirmedPropertyPurchases: (state) => {return [state.purchases.filter(p => p.CheckerID == 0 && p.AssetType == 3),[state.purchases.title = "Property Purchases"]]},
    allSales: (state) => state.sales,
    allBondSales: (state) => state.sales.filter(s => s.AssetType == 1),
    unconfirmedBondSales: (state) => {return [state.sales.filter(s => s.CheckerID == 0 && s.AssetType == 1),[state.sales.title = "Bond Sales"]]},
    allEquitySales: (state) => state.sales.filter(s => s.AssetType == 2),
    unconfirmedEquitySales: (state) => {return [state.sales.filter(s => s.CheckerID == 0 && s.AssetType == 2),[state.sales.title = "Equity Sales"]]},
    allMMSales: (state) => state.sales.filter(s => s.AssetType == 4),
    unconfirmedMMSales: (state) => {return [state.sales.filter(s => s.CheckerID == 0 && s.AssetType == 4),[state.sales.title = "Money Market Sales"]]},
    allPropertySales: (state) => state.sales.filter(s => s.AssetType == 3),
    unconfirmedPropertySales: (state) => {return [state.sales.filter(s => s.CheckerID == 0 && s.AssetType == 3),[state.sales.title = "Property Sales"]]},
    allAssetTransfersEquity: (state) => state.assetTransfersEquity,
    unconfirmedAssetTrasnfersEquity: (state) => {return [state.assetTransfersEquity.filter(s => s.CheckerID == 0),[state.assetTransfersEquity.title = "Internal Asset Transfers"]]},
    allReversals: (state) => state.reversals,
    unconfirmedReversals: (state) => {return [state.reversals.filter(d => d.CheckerID == 0),[state.reversals.title = "Reversals"]]},
    allCounters: (state) => state.counters,
    allUnlistedCounters: (state) => state.unlistedCounters,
  },

//********************************************************************ACTIONS*****************************************************************************************
//********************************************************************************************************************************************************************

  actions: {

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// PURCHASES

  createPurchase({ commit }, data) {
      return dealingService.createPurchase(data).then(
        response => {
          commit('newPurchase', response.data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },
    getAllPurchases({ commit }) {
      return dealingService.getAllPurchases().then(
        response => {
          commit('setPurchases', response.data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },
    retrieveCounters({ commit }) {
      return dealingService.getCounters().then(
        response => {
          commit('setCounters', response.data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },
    retrieveUnlistedCounters({ commit }) {
      return dealingService.getUnlistedCounters().then(
        response => {
          commit('setUnlistedCounters', response.data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },
    updatePurchaseStatus({ commit }, data) {
      return dealingService.updatePurchaseStatus(data.PurchaseID, data).then(
        response => {
          commit('updPurchase', data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },
    updatePurchase({ commit }, data) {
      return dealingService.updatePurchase(data.PurchaseID, data).then(
        response => {
          commit('updPurchase', data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// SALES

    createSale({ commit }, data) {
      return dealingService.createSale(data).then(
        response => {
          commit('newSale', response.data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },
    getAllSales({ commit }) {
      return dealingService.getAllSales().then(
        response => {
          commit('setSales', response.data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },
    updateSaleStatus({ commit }, data) {
      return dealingService.updateSaleStatus(data.SaleID, data).then(
        response => {
          commit('updSale', data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },
    updateSale({ commit }, data) {
      return dealingService.updateSale(data.SaleID, data).then(
        response => {
          commit('updSale', data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// ASSET TRANSFERS EQUITY

    createAssetTransferEquity({ commit }, data) {
      return dealingService.createAssetTransferEquity(data).then(
        response => {
          commit('newAssetTransferEquity', response.data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },
    getAllAssetTransfersEquity({ commit }) {
      return dealingService.getAllAssetTransfersEquity().then(
        response => {
          commit('setAssetTransfersEquity', response.data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },
    updateAssetTransferEquity({ commit }, data) {
      return dealingService.updateAssetTransferEquity(data.TransferID, data).then(
        response => {
          commit('updAssetTransferEquity', data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },
    deleteAssetTransferEquity({ commit }, data) {
      return dealingService.deleteAssetTransferEquity(data.TransferID).then(
        response => {
          commit('dltAssetTransferEquity', data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// REVERSALS

    createReversal({ commit }, data) {
      return dealingService.captureUpdateReversal(data).then(
        response => {
          commit('newReversal', response.data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },
    getAllReversals({ commit }) {
      return dealingService.findAllReversals().then(
        response => {
          commit('setReversals', response.data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },
    captureUpdateReversal({ commit }, data) {
      return dealingService.captureUpdateReversal(data).then(
        response => {
          commit('updReversal', response.data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },
  },

//********************************************************************MUTATIONS***************************************************************************************
//********************************************************************************************************************************************************************
  mutations: {

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// PURCHASES

    setPurchases: (state, purchases) => (state.purchases = purchases),
    setCounters: (state, counters) => (state.counters = counters),
    setUnlistedCounters: (state, counters) => (state.unlistedCounters = counters),
    newPurchase: (state, newPurchase) => state.purchases.unshift(newPurchase.purchase),
    updPurchase: (state, updatedPurchase) => {
      const index = state.purchases.findIndex(purchases => purchases.PurchaseID === updatedPurchase.PurchaseID);
      if (index !== -1) {
        state.purchases.splice(index, 1, updatedPurchase);
      }
    },

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// SALES

    setSales: (state, sales) => (state.sales = sales),
    newSale: (state, newSale) => state.sales.unshift(newSale.sale),
    updSale: (state, updatedSale) => {
      const index = state.sales.findIndex(sales => sales.SaleID === updatedSale.SaleID);
      if (index !== -1) {
        state.sales.splice(index, 1, updatedSale);
      }
    },

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// ASSET TRANSFERS EQUITY

    setAssetTransfersEquity: (state, AssetTransfers) => (state.assetTransfersEquity = AssetTransfers),
    newAssetTransferEquity: (state, newAssetTransfer) => state.assetTransfersEquity.unshift(newAssetTransfer.asset_transfer_equity),
    updAssetTransferEquity: (state, updatedTransfer) => {
      const index = state.assetTransfersEquity.findIndex(assetTransfersEquity => assetTransfersEquity.TransferID === updatedTransfer.TransferID);
      if (index !== -1) {
        state.assetTransfersEquity.splice(index, 1, updatedTransfer);
      }
    },
    dltAssetTransferEquity: (state, AssetTransfer) => {
      const index = state.assetTransfersEquity.findIndex(assetTransfersEquity => assetTransfersEquity.TransferID === AssetTransfer.TransferID);
      if (index !== -1) {
        state.assetTransfersEquity.splice(index, 1);
      }
    },

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// REVERSALS

    setReversals: (state, Reversals) => (state.reversals = Reversals),
    newReversal: (state, newReversal) => state.reversals.unshift(newReversal.reversal),
    updReversal: (state, update) => {
      const index = state.reversals.findIndex(r => r.ReversalID === update.reversal.ReversalID);
      if (index !== -1) {
        state.reversals.splice(index, 1, update.reversal);
      } else {
        state.reversals.unshift(update.reversal)
      }
    },
  },
}
